var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _g3, _rect, _rect2, _path36, _path37, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProgressFifth = function SvgProgressFifth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 544 473"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#progress_fifth_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 399,
    x: 122.451,
    y: 27,
    fill: "#fff",
    rx: 9.797
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#progress_fifth_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.518,
    height: 59.518,
    fill: "#FFB800",
    rx: 16,
    transform: "matrix(-1 0 0 1 143.97 50)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.167,
    d: "M120.784 73.667v-4.75a3.176 3.176 0 0 1 3.167-3.167m-9.5 15.833h6.333m-6.333-13.458a3.962 3.962 0 0 0-6.353-3.175 3.96 3.96 0 0 0-1.501 2.447 3.955 3.955 0 0 0-3.164 3.173 4 4 0 0 0 .029 1.577 3.96 3.96 0 0 0-3.087 2.72 3.96 3.96 0 0 0 .997 3.993 4.752 4.752 0 0 0 .539 8.835 3.96 3.96 0 0 0 .972 3.756 3.96 3.96 0 0 0 3.714 1.12 3.96 3.96 0 0 0 7.774.08l.08.016z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.167,
    d: "M114.451 89.5h9.5a3.166 3.166 0 0 1 3.167 3.167v1.583m-12.667-20.583h12.667m.792 0a.794.794 0 0 1-.792.791.793.793 0 0 1-.56-1.351.793.793 0 0 1 1.352.56m-6.334 7.916a.79.79 0 0 1-.791.792.791.791 0 1 1 .791-.792"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.167,
    d: "M127.909 94.25a.79.79 0 0 1-.791.792.791.791 0 1 1 .791-.792m-3.166-28.5a.794.794 0 0 1-1.352.56.794.794 0 0 1 0-1.12.793.793 0 0 1 1.352.56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#68ADFF",
    d: "M173.201 68a3.76 3.76 0 0 0-3.75 3.75v52.5a3.76 3.76 0 0 0 3.75 3.75h37.5a3.76 3.76 0 0 0 3.75-3.75V81.954L200.369 68z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M203.666 81.954h10.785L200.389 68v10.623c0 1.952 1.3 3.33 3.277 3.33"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#68ADFF",
    d: "M173.201 151a3.76 3.76 0 0 0-3.75 3.75v52.5a3.76 3.76 0 0 0 3.75 3.75h37.5a3.76 3.76 0 0 0 3.75-3.75v-42.297L200.369 151z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M203.666 164.953h10.785L200.389 151v10.623c0 1.952 1.3 3.33 3.277 3.33"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#68ADFF",
    d: "M173.201 234a3.76 3.76 0 0 0-3.75 3.75v52.5a3.76 3.76 0 0 0 3.75 3.75h37.5a3.76 3.76 0 0 0 3.75-3.75v-42.297L200.369 234z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M203.666 247.953h10.785L200.389 234v10.623c0 1.952 1.3 3.33 3.277 3.33"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#68ADFF",
    d: "M173.201 327a3.76 3.76 0 0 0-3.75 3.75v52.5a3.76 3.76 0 0 0 3.75 3.75h37.5a3.76 3.76 0 0 0 3.75-3.75v-42.297L200.369 327z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M203.666 340.953h10.785L200.389 327v10.623c0 1.952 1.3 3.33 3.277 3.33"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#68ADFF",
    d: "M257.201 68a3.76 3.76 0 0 0-3.75 3.75v52.5a3.76 3.76 0 0 0 3.75 3.75h37.5a3.76 3.76 0 0 0 3.75-3.75V81.954L284.369 68z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M287.666 81.954h10.785L284.389 68v10.623c0 1.952 1.3 3.33 3.277 3.33"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#68ADFF",
    d: "M257.201 151a3.76 3.76 0 0 0-3.75 3.75v52.5a3.76 3.76 0 0 0 3.75 3.75h37.5a3.76 3.76 0 0 0 3.75-3.75v-42.297L284.369 151z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M287.666 164.953h10.785L284.389 151v10.623c0 1.952 1.3 3.33 3.277 3.33"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#68ADFF",
    d: "M257.201 234a3.76 3.76 0 0 0-3.75 3.75v52.5a3.76 3.76 0 0 0 3.75 3.75h37.5a3.76 3.76 0 0 0 3.75-3.75v-42.297L284.369 234z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M287.666 247.953h10.785L284.389 234v10.623c0 1.952 1.3 3.33 3.277 3.33"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#68ADFF",
    d: "M257.201 327a3.76 3.76 0 0 0-3.75 3.75v52.5a3.76 3.76 0 0 0 3.75 3.75h37.5a3.76 3.76 0 0 0 3.75-3.75v-42.297L284.369 327z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M287.666 340.953h10.785L284.389 327v10.623c0 1.952 1.3 3.33 3.277 3.33"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#68ADFF",
    d: "M341.201 68a3.76 3.76 0 0 0-3.75 3.75v52.5a3.76 3.76 0 0 0 3.75 3.75h37.5a3.76 3.76 0 0 0 3.75-3.75V81.954L368.369 68z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M371.666 81.954h10.785L368.389 68v10.623c0 1.952 1.3 3.33 3.277 3.33"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#68ADFF",
    d: "M341.201 151a3.76 3.76 0 0 0-3.75 3.75v52.5a3.76 3.76 0 0 0 3.75 3.75h37.5a3.76 3.76 0 0 0 3.75-3.75v-42.297L368.369 151z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M371.666 164.953h10.785L368.389 151v10.623c0 1.952 1.3 3.33 3.277 3.33"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#68ADFF",
    d: "M341.201 234a3.76 3.76 0 0 0-3.75 3.75v52.5a3.76 3.76 0 0 0 3.75 3.75h37.5a3.76 3.76 0 0 0 3.75-3.75v-42.297L368.369 234z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M371.666 247.953h10.785L368.389 234v10.623c0 1.952 1.3 3.33 3.277 3.33"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#68ADFF",
    d: "M341.201 327a3.76 3.76 0 0 0-3.75 3.75v52.5a3.76 3.76 0 0 0 3.75 3.75h37.5a3.76 3.76 0 0 0 3.75-3.75v-42.297L368.369 327z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M371.666 340.953h10.785L368.389 327v10.623c0 1.952 1.3 3.33 3.277 3.33"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#68ADFF",
    d: "M425.201 68a3.76 3.76 0 0 0-3.75 3.75v52.5a3.76 3.76 0 0 0 3.75 3.75h37.5a3.76 3.76 0 0 0 3.75-3.75V81.954L452.369 68z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M455.666 81.954h10.785L452.389 68v10.623c0 1.952 1.3 3.33 3.277 3.33"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#68ADFF",
    d: "M425.201 151a3.76 3.76 0 0 0-3.75 3.75v52.5a3.76 3.76 0 0 0 3.75 3.75h37.5a3.76 3.76 0 0 0 3.75-3.75v-42.297L452.369 151z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M455.666 164.953h10.785L452.389 151v10.623c0 1.952 1.3 3.33 3.277 3.33"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#68ADFF",
    d: "M425.201 234a3.76 3.76 0 0 0-3.75 3.75v52.5a3.76 3.76 0 0 0 3.75 3.75h37.5a3.76 3.76 0 0 0 3.75-3.75v-42.297L452.369 234z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M455.666 247.953h10.785L452.389 234v10.623c0 1.952 1.3 3.33 3.277 3.33"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#68ADFF",
    d: "M425.201 327a3.76 3.76 0 0 0-3.75 3.75v52.5a3.76 3.76 0 0 0 3.75 3.75h37.5a3.76 3.76 0 0 0 3.75-3.75v-42.297L452.369 327z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M455.666 340.953h10.785L452.389 327v10.623c0 1.952 1.3 3.33 3.277 3.33"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#progress_fifth_svg__c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 446,
    height: 93,
    x: 33.451,
    y: 264,
    fill: "#fff",
    rx: 3.756
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 403.97,
    height: 19.173,
    x: 51.451,
    y: 315,
    fill: "#E2FFEA",
    rx: 9.587
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 245.661,
    height: 19.173,
    x: 51.451,
    y: 315,
    fill: "#51C394",
    rx: 9.587
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D4E6D",
    d: "M52.686 285.788h1.824v10.818h-1.824zm1.082 1.607v-1.607h2.179q1.175 0 2.04.417.88.402 1.36 1.159.48.742.479 1.778 0 1.035-.48 1.792-.478.758-1.36 1.175-.864.402-2.04.402h-2.178v-1.608h2.179q.942 0 1.514-.448t.572-1.313q0-.866-.572-1.299-.571-.447-1.514-.448zm9.065 2.102v7.109H61.18v-7.109zm2.118 1.777a2.2 2.2 0 0 0-.433-.278 1.2 1.2 0 0 0-.51-.093q-.417 0-.68.217a1.25 1.25 0 0 0-.387.602 3.2 3.2 0 0 0-.108.881l-.556-.324q0-.85.309-1.499.325-.665.819-1.051.51-.387 1.05-.387.387 0 .727.124.34.108.572.402zm1.181 1.778q0-1.098.495-1.932a3.54 3.54 0 0 1 1.375-1.298q.865-.48 1.963-.48 1.096 0 1.947.48a3.54 3.54 0 0 1 1.376 1.298q.51.834.51 1.932 0 1.082-.51 1.931-.51.836-1.376 1.314-.85.464-1.947.464-1.098 0-1.963-.464a3.66 3.66 0 0 1-1.375-1.314q-.495-.85-.495-1.931m1.716 0q0 .664.278 1.174.278.495.757.788.48.279 1.082.278a2.1 2.1 0 0 0 1.066-.278q.495-.293.773-.788.279-.51.278-1.174 0-.665-.278-1.175a1.96 1.96 0 0 0-.773-.788 2.1 2.1 0 0 0-1.066-.278 2.1 2.1 0 0 0-1.082.278 2 2 0 0 0-.757.788q-.279.51-.278 1.175m7.132 4.033h1.653q.015.48.263.866.263.386.71.602.45.217 1.036.217.525 0 1.005-.248.48-.246.772-.757.31-.51.31-1.313v-6.955h1.638v6.955q0 1.282-.526 2.117-.51.834-1.344 1.236a4 4 0 0 1-1.808.417q-1.159 0-1.979-.401a2.94 2.94 0 0 1-1.267-1.098q-.433-.711-.463-1.638m-.14-4.064q0-1.19.48-1.994a3.3 3.3 0 0 1 1.267-1.252 3.6 3.6 0 0 1 1.715-.433q.897 0 1.561.449.68.432 1.067 1.251.4.82.401 1.979 0 1.143-.401 1.962-.387.82-1.067 1.268-.664.432-1.56.432a3.6 3.6 0 0 1-1.716-.432 3.3 3.3 0 0 1-1.267-1.252q-.48-.82-.48-1.978m1.731 0q0 .71.294 1.205t.773.757q.495.248 1.066.248.48 0 .943-.248.48-.247.772-.741.31-.51.31-1.221 0-.557-.186-.959a1.96 1.96 0 0 0-.464-.695 1.85 1.85 0 0 0-.664-.433 2 2 0 0 0-.71-.139 2.24 2.24 0 0 0-1.067.263q-.48.247-.773.742-.294.493-.294 1.221m9.52-3.524v7.109h-1.654v-7.109zm2.117 1.777a2.2 2.2 0 0 0-.433-.278 1.2 1.2 0 0 0-.51-.093q-.417 0-.68.217a1.25 1.25 0 0 0-.386.602 3.2 3.2 0 0 0-.109.881l-.556-.324q0-.85.309-1.499.325-.665.82-1.051.51-.387 1.05-.387.387 0 .726.124.34.108.572.402zm4.813 5.487q-1.082 0-1.916-.464a3.2 3.2 0 0 1-1.267-1.298q-.45-.836-.449-1.947 0-1.13.449-1.963.463-.835 1.298-1.283.834-.464 1.962-.464t1.917.433 1.205 1.252q.433.804.433 1.947 0 .124-.016.263 0 .14-.015.201h-6.244v-1.144H95.2l-.51.711q.046-.093.093-.247a.9.9 0 0 0 .062-.278q0-.572-.232-.989a1.56 1.56 0 0 0-.618-.649 1.74 1.74 0 0 0-.912-.232q-.633 0-1.082.278a1.74 1.74 0 0 0-.68.804q-.231.525-.247 1.298 0 .773.232 1.313.23.527.68.804.464.278 1.112.278.68 0 1.19-.278t.85-.85l1.438.587q-.556.958-1.438 1.438-.88.479-2.117.479m5.55-2.489q.34.372.68.65.356.263.71.401.356.124.711.124.449 0 .696-.201a.66.66 0 0 0 .263-.556.75.75 0 0 0-.201-.526 1.5 1.5 0 0 0-.557-.386 9 9 0 0 0-.834-.34 10 10 0 0 1-.958-.433 2.5 2.5 0 0 1-.773-.68q-.294-.417-.294-1.051 0-.648.325-1.082a1.96 1.96 0 0 1 .896-.633 3.4 3.4 0 0 1 1.221-.217q.587 0 1.097.17.526.17.943.449.417.278.711.633l-.927.989a2.9 2.9 0 0 0-.85-.68 2.15 2.15 0 0 0-1.02-.262q-.356 0-.588.154a.5.5 0 0 0-.231.448q0 .248.2.449.217.185.557.34.356.155.788.324.587.232 1.082.51t.788.68q.309.402.309 1.051 0 1.005-.695 1.623-.68.602-1.855.602a4 4 0 0 1-1.344-.216 4.2 4.2 0 0 1-1.067-.587 4.8 4.8 0 0 1-.757-.773zm6.55 0q.34.372.68.65.356.263.711.401.355.124.71.124.449 0 .696-.201a.66.66 0 0 0 .263-.556.75.75 0 0 0-.201-.526 1.5 1.5 0 0 0-.557-.386 9 9 0 0 0-.834-.34 10 10 0 0 1-.958-.433 2.5 2.5 0 0 1-.773-.68q-.294-.417-.294-1.051 0-.648.325-1.082.34-.432.896-.633a3.4 3.4 0 0 1 1.221-.217q.587 0 1.097.17.526.17.943.449.417.278.711.633l-.927.989a2.9 2.9 0 0 0-.85-.68 2.15 2.15 0 0 0-1.02-.262q-.356 0-.588.154a.5.5 0 0 0-.231.448q0 .248.201.449.216.185.556.34.356.155.788.324.588.232 1.082.51t.788.68q.309.402.309 1.051 0 1.005-.695 1.623-.68.602-1.855.602-.726 0-1.344-.216a4.2 4.2 0 0 1-1.067-.587 4.8 4.8 0 0 1-.757-.773z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#51C394",
    d: "M418.192 296.567q0 1.49-.553 2.572a5.05 5.05 0 0 1-1.491 1.779 6.5 6.5 0 0 1-2.091 1.034 8.5 8.5 0 0 1-2.38.336q-1.54 0-2.765-.36a8.6 8.6 0 0 1-2.115-.938q-.913-.6-1.611-1.298l1.611-2.668q.6.6 1.298 1.081.721.481 1.49.77a4.5 4.5 0 0 0 1.467.264q1.081 0 1.827-.336.769-.337 1.178-.962.408-.65.408-1.587 0-.913-.48-1.538-.457-.625-1.251-.938a4.15 4.15 0 0 0-1.682-.336q-.674 0-1.419.12a8 8 0 0 0-1.538.36 9 9 0 0 0-1.635.722l2.308-9.472h9.159v2.981h-6.611l-1.01 3.462a4.3 4.3 0 0 1 1.323-.457 7.5 7.5 0 0 1 1.466-.144q1.37 0 2.524.673 1.155.673 1.851 1.923.722 1.226.722 2.957m5.267-2.981q0 1.274.241 2.332.24 1.034.697 1.803.456.745 1.082 1.154.624.408 1.394.408.794 0 1.418-.408.626-.409 1.082-1.154.457-.77.697-1.803.241-1.058.241-2.332 0-1.275-.241-2.308-.24-1.058-.697-1.803-.456-.769-1.082-1.178a2.54 2.54 0 0 0-1.418-.409q-.77 0-1.394.409-.626.409-1.082 1.178-.457.745-.697 1.803a10.2 10.2 0 0 0-.241 2.308m-3.341 0q0-2.669.841-4.616.865-1.947 2.38-3.005 1.539-1.082 3.534-1.082 2.067 0 3.582 1.082 1.515 1.058 2.356 3.005t.841 4.616-.841 4.616-2.356 3.029q-1.515 1.057-3.582 1.057-1.995 0-3.534-1.057-1.515-1.082-2.38-3.029-.841-1.948-.841-4.616m15.111-4.544q0-1.201.553-2.163a4.17 4.17 0 0 1 1.562-1.515q.986-.577 2.212-.577 1.25 0 2.212.577.986.554 1.538 1.515.553.962.553 2.163 0 1.155-.553 2.14a4.16 4.16 0 0 1-1.538 1.538q-.962.577-2.212.577-1.226 0-2.212-.577a4.35 4.35 0 0 1-1.562-1.538 4.3 4.3 0 0 1-.553-2.14m2.596 0q0 .481.217.914.216.409.601.649.384.24.913.24t.89-.24q.384-.24.601-.649.216-.433.216-.914 0-.505-.216-.913a1.7 1.7 0 0 0-.601-.649q-.361-.265-.89-.265-.53 0-.913.265-.385.24-.601.649a1.9 1.9 0 0 0-.217.913m8.342 9.088q0-1.179.553-2.14a4.1 4.1 0 0 1 1.563-1.539q.985-.577 2.211-.577 1.25 0 2.212.577.986.553 1.539 1.539a4.2 4.2 0 0 1 .553 2.14 4.2 4.2 0 0 1-.553 2.139 4.2 4.2 0 0 1-1.539 1.539q-.961.577-2.212.577-1.226 0-2.211-.577a4.37 4.37 0 0 1-1.563-1.539 4.2 4.2 0 0 1-.553-2.139m2.596 0q0 .48.217.913.216.41.601.649.384.24.913.241.529 0 .89-.241a1.67 1.67 0 0 0 .601-.649q.216-.433.216-.913 0-.506-.216-.914a1.7 1.7 0 0 0-.601-.649q-.361-.24-.89-.24-.528 0-.913.24a1.67 1.67 0 0 0-.601.649 1.9 1.9 0 0 0-.217.914m.818-12.958h3.149L440.47 302h-3.15z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "progress_fifth_svg__a",
    width: 457.477,
    height: 472.477,
    x: 85.712,
    y: 0.261,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.369
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_578_13786"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_578_13786",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "progress_fifth_svg__b",
    width: 152.103,
    height: 152.102,
    x: 40.804,
    y: 14.289,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.645,
    dy: 10.581
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23.146
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_578_13786"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_578_13786",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "progress_fifth_svg__c",
    width: 511.735,
    height: 158.735,
    x: 0.584,
    y: 242.088,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.956
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.434
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_578_13786"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_578_13786",
    result: "shape"
  })))));
};
export default SvgProgressFifth;